// 스타일
import './view.scss';

// 스크립트
import './assets/script/theme.js'
import './assets/parts/footer/style.js'
import './assets/parts/header/style.js'
import './assets/parts/navigation/style.js'
import './assets/parts/search-overlay/style.js'
import './assets/parts/sidebar/style.js'
import './assets/parts/single-post/style.js'
import './assets/lib/aos/init.js'
import './assets/lib/typing/init.js'
import './assets/lib/mask/init.js'
import './assets/lib/count/init.js'
import './assets/lib/accordion/init.js'
import './assets/lib/tabs/init.js'
import './assets/lib/sticky/init.js'
import './assets/lib/share/init.js'

// 슬라이더
// import './assets/lib/swiper/init.js'

/**
 * 블록 스크롤 고정
 * 블록 테마에서 설정함
 */
window.addEventListener('DOMContentLoaded', () => {

  // debounce 함수 정의
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // 스로틀링 함수 정의
  function throttle(func, delay) {
    let lastTime = 0;
    return function(...args) {
      const now = new Date().getTime();
      if (now - lastTime >= delay) {
        func.apply(this, args);
        lastTime = now;
      }
    };
  }

  // 리랜더링
  function reRendering (wrapper, element, posTop, posLeft, posRight, posTiming) {
    const display = window.getComputedStyle(element).display;
    if (display === 'none') {
      wrapper.style.height = '';
      wrapper.classList.remove('is-block-sticky');
      element.style.top = `${posTop}px`;
      element.style.left = posLeft !== undefined && posLeft !== null ? `${posLeft}px` : undefined;
      element.style.right = posRight !== undefined && posRight !== null ? `${posRight}px` : undefined;
    } else {
      // console.log(posTiming)
      // if (element.getBoundingClientRect().height) {
      //   wrapper.style.height = `${element.getBoundingClientRect().height}px`;
      // } else {
      //   if (!wrapper.classList.contains('is-block-sticky')) {
      //     element.style.top = '';
      //   }
      //   wrapper.style.height = '';
      // }
    }
  }

  // 스틱키 요소 정의
  const stickyElements = document.querySelectorAll('.block-sticky');
  stickyElements.forEach((element) => {

    const get_adminbar_position = () => {
      let gap = 0;
      const adminbar = document.querySelector('#wpadminbar');
      if (adminbar) {
        const elStyle = window.getComputedStyle(adminbar);
        if (elStyle.position === 'fixed') {
          gap = adminbar.getBoundingClientRect().height;
        }
      }
      return gap;
    }

    // 데이터 속성 얻기
    let scroll_gap = get_adminbar_position();
    let posTop = parseInt(element.dataset.top || 0) + scroll_gap || 0 + scroll_gap ;
    let posLeft = element.dataset.left ? parseInt(element.dataset.left) : undefined ;
    let posRight = element.dataset.right ? parseInt(element.dataset.right) : undefined ;
    let posTiming = element.dataset.stickytiming || '';

    // 래퍼(wrapper) 요소 생성
    const wrapper = document.createElement('div');
    wrapper.classList.add('block-sticky-holder');
    element.parentNode.insertBefore(wrapper, element);

    // 요소 높이를 미리 지정
    if (element.getBoundingClientRect().height) {
      wrapper.style.height = `${element.getBoundingClientRect().height}px`;
    } else {
      wrapper.style.height = ''; 
    }

    let observer;
    function setOverserver () {

      // 기존 옵저버 해제
      if (observer) {
        observer.disconnect();
      }

      // 한번 더 정의
      scroll_gap = get_adminbar_position();
      posTop = parseInt(element.dataset?.top) + scroll_gap || 0 + scroll_gap ;

      // 옵저버 컨테이너
      observer = new IntersectionObserver(
        ([entry]) => {

          // 타이밍 계산
          if (
            posTiming === 'meet' && 
            entry.boundingClientRect.width && 
            window.innerHeight > posTop + wrapper.getBoundingClientRect().height && 
            (
              (entry.boundingClientRect.width === entry.intersectionRect.width && entry.intersectionRatio < 1) || 
              (entry.intersectionRatio === 0 && posTop > wrapper.getBoundingClientRect().top)
            )
          ) {
            wrapper.style.height = `${element.getBoundingClientRect().height}px`;
            entry.target.classList.add('is-block-sticky');
            element.style.animation = undefined;
            element.style.top = `${posTop}px`;
            element.style.left = posLeft !== undefined && posLeft !== null ? `${posLeft}px` : undefined;
            element.style.right = posRight !== undefined && posRight !== null ? `${posRight}px` : undefined;
          } else if (!entry.isIntersecting && posTiming != 'meet') {
            wrapper.style.height = `${element.getBoundingClientRect().height}px`;
            entry.target.classList.add('is-block-sticky');
            element.style.top = `${posTop}px`;
            element.style.left = posLeft !== undefined && posLeft !== null ? `${posLeft}px` : undefined;
            element.style.right = posRight !== undefined && posRight !== null ? `${posRight}px` : undefined;
          } else {
            entry.target.classList.remove('is-block-sticky');
            element.style.top = '';
            element.style.left = '';
            element.style.right = '';
            wrapper.style.height = ''; 
          }

        },
        { 
          root: document,
          threshold: [0, 1],
          rootMargin: `-${posTop}px 0px -${posTop}px 0px`
        }
      );

      // 옵저버 수행
      observer.observe(wrapper);

    }

    // 자식 노드 삽입
    wrapper.appendChild(element);

    // 첫번째 옵저버 실행
    setOverserver();

    // 리사이즈 핸들러 정의
    const handleImmediateResize = throttle(() => {
      // reRendering(wrapper, element, posTop, posLeft, posRight, posTiming);
    }, 0); // 즉시 실행

    // 리사이즈 옵저버 업데이트 .3s
    const handleDebouncedResize = debounce(() => {
      // reRendering(wrapper, element, posTop, posLeft, posRight, posTiming);
      setOverserver();
    }, 300); // {x}ms 이후에 실행

    // 리사이즈 이벤트 리스너 추가
    window.addEventListener('resize', () => {
      // handleImmediateResize();
      handleDebouncedResize();
      // observer.unobserve(wrapper);
      // observer.observe(wrapper);
    });

  });

});

/**
 * 외부에서 GNB 메뉴 열기
 */
window.addEventListener('DOMContentLoaded', () => {
  const gnb_menu_btns = document.querySelectorAll('.header-gnb-toggle-btn');
  gnb_menu_btns.forEach(btn => {
    btn.addEventListener('click', function () {
      const header_gnb_btn = document.querySelector('.header-gnb .wp-block-navigation__responsive-container-open');
      header_gnb_btn.click();
    });
  });
});